export const appSettings = {
	appTitle : 'Agent Early start',
	appLogo  : '/assets/images/logo/logo.jpg',
};
